import classNames from 'classnames';
import React from 'react';

import '@eika/card-style/src/SuccessCard.scss';
import { CheckmarkAnimation, CheckmarkAnimationTypes } from '@eika/checkmark-animation';

export type SuccessCardProps = {
    title: React.ReactNode;
    centeredWithMargin?: boolean;
} & React.PropsWithChildren;

const SuccessCard: React.FC<SuccessCardProps> = ({ title, centeredWithMargin = false, children }) => {
    const titleIsString = typeof title === 'string';
    return (
        <div className={classNames('sgw-success-card', { 'centered-with-margin': centeredWithMargin })}>
            <CheckmarkAnimation
                className="sgw-success-card__checkmark--centered"
                checkmarkAnimationType={CheckmarkAnimationTypes.POSITIVE}
            />
            {titleIsString ? (
                <h3 className="sgw-success-card__title typography-h3">{title}</h3>
            ) : (
                <div className="sgw-success-card__title">{title}</div>
            )}
            {children}
        </div>
    );
};

export default SuccessCard;
